<template>
  <div class="entry-section">
    <div class="container">
      <header class="entry-section__header">
        <small class="small-txt">{{ $t('100percentMadeInAustria') }} </small>
        <h1 class="heading" v-html="$t('windowConfigurator')"></h1>
        <span class="less-txt">{{ $t('allSpeaksForInternorm') }}</span>
      </header>
      <div class="entry-section__buttons">
        <router-link
          class="btn-main-primary"
          :to="{ name: 'configurator', query: { type: 'full' } }"
        >
          <span class="icon icon-play-button" aria-hidden="true"></span>
          <span v-html="$t('iWillCompleteFullConfiguration')"></span>
          <span class="txt">{{ $t('begin') }}</span>
        </router-link>

        <router-link
          class="btn-main-secondary"
          :to="{ name: 'configurator', query: { type: 'project' } }"
        >
          <span class="icon icon-design-tool" aria-hidden="true"></span>
          <span v-html="$t('configurationBasedOnProject')"></span>
          <small>{{ $t('projectBasedConfigurationInfo') }}</small>
          <span class="txt">{{ $t('iWantToAddFiles') }}</span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import store from '@/store';

  export default {
    name: 'Home',
    beforeRouteEnter: (to, from, next) => {
      const { configurationType, configurations } = store.state;

      if (configurationType && configurations.length > 0) {
        next({ name: 'configurator', query: { type: configurationType } });
      } else {
        next();
      }
    }
  };
</script>
